// // src/hooks/useOfflineData.js
// import { useState, useEffect } from 'react';

// export function useOfflineData(apiCall, dbGetMethod, dbSaveMethod) {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     async function loadData() {
//       try {
//         if (navigator.onLine) {
//           // Try API first when online
//           const response = await apiCall();
//           let result = response.results || response.data?.results || response.data || response;
          
//           // Handle arrays
//           if (!Array.isArray(result)) {
//             result = [];
//           }
          
//           setData(result);
          
//           // Save to IndexedDB if save method provided
//           if (dbSaveMethod && result.length > 0) {
//             await dbSaveMethod(result);
//           }
//         } else {
//           // Load from IndexedDB when offline
//           if (dbGetMethod) {
//             const cached = await dbGetMethod();
//             setData(cached || []);
//           }
//         }
//       } catch (err) {
//         console.error('API error, trying cache:', err);
//         // Fallback to cache on error
//         if (dbGetMethod) {
//           try {
//             const cached = await dbGetMethod();
//             setData(cached || []);
//           } catch (cacheErr) {
//             setError('Unable to load data');
//             setData([]);
//           }
//         }
//       } finally {
//         setLoading(false);
//       }
//     }

//     loadData();
//   }, []);

//   return { data, loading, error };
// }


// src/hooks/useOfflineData.js
import { useState, useEffect, useCallback } from 'react';

export function useOfflineData(apiCall, dbGetMethod, dbSaveMethod) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    setLoading(true);

    // ⭐ STEP 1: Load from IndexedDB immediately — no spinner wait
    if (dbGetMethod) {
      try {
        const cached = await dbGetMethod();
        if (cached && cached.length > 0) {
          setData(cached);
          setLoading(false); // ⭐ Stop spinner right away with local data
        }
      } catch (cacheErr) {
        console.error('Cache read failed:', cacheErr);
      }
    }

    // ⭐ STEP 2: Fetch from API in background (online only)
    if (navigator.onLine) {
      try {
        const response = await apiCall();
        let result = response.results || response.data?.results || response.data || response;

        if (!Array.isArray(result)) {
          result = [];
        }

        // Save fresh data to IndexedDB
        if (dbSaveMethod && result.length > 0) {
          await dbSaveMethod(result);
        }

        // ⭐ Silently update UI with fresh data
        setData(result);

      } catch (err) {
        console.error('API fetch failed, using cached data:', err);
        // Already showing cached data from Step 1 — nothing else to do
        if (data.length === 0) {
          setError('Unable to load fresh data');
        }
      }
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  // ⭐ Expose refetch so components can manually trigger a refresh
  return { data, loading, error, refetch: loadData };
}